import { useQuery } from '@apollo/react-hooks';
import { useEffect } from 'react';

import { END_OF_TRIAL_PAGE_INSIGHTS_EXPERIENCE } from '@confluence/experience-tracker';

import { PageInsightsQuery } from '../../queries/PageInsights.graphql';
import { useEndOfTrialModalAnalytics } from '../analytics-handlers/useEndOfTrialModalAnalytics';
import { useHandleHookStates, INSIGHTS } from '../useHandleHookStates';
import { useFeatureUsageActions } from '../../store/featureUsageStore';
import type { PageInsightsQuery as PageInsightsQueryType } from '../../queries/__types__/PageInsightsQuery';
import { useExperimentInfo } from '../../store/experimentInfoStore';
import { statsigCohorts } from '../../experimentConstants';

export const useCheckPageInsights = () => {
	const { setTotalPageViews } = useFeatureUsageActions();
	const { cohort } = useExperimentInfo();
	const { data, loading, error } = useQuery<PageInsightsQueryType>(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
		PageInsightsQuery,
		{
			variables: {
				status: ['current'],
				type: 'page',
			},
			skip: cohort !== statsigCohorts.TREATMENT,
		},
	);

	const { handleHookError } = useEndOfTrialModalAnalytics({
		experienceName: END_OF_TRIAL_PAGE_INSIGHTS_EXPERIENCE,
		errorSource: 'useCheckPageInsights',
	});

	useHandleHookStates({ loading, error, hook: INSIGHTS });

	useEffect(() => {
		if (error) {
			handleHookError(error);
		}
	}, [handleHookError, error]);

	useEffect(() => {
		if (data) {
			void setTotalPageViews(
				data?.content?.edges?.reduce(
					(acc, edge) => acc + (edge?.node?.contentAnalyticsViewers?.count || 0),
					0,
				) || 0,
			);
		}
	}, [data, setTotalPageViews]);
};
